// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file actions/v1/workflow_runs_route.proto (package github.actions.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SafeHtml } from "../../common/v1/safe_html_pb";
import { file_common_v1_safe_html } from "../../common/v1/safe_html_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file actions/v1/workflow_runs_route.proto.
 */
export const file_actions_v1_workflow_runs_route: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v1_safe_html, file_google_protobuf_timestamp, file_google_protobuf_wrappers]);

/**
 * Main DataRouter payload for the all-workflows and selected-workflow routes.
 * Produced by ActionsController#index.
 *
 * @generated from message github.actions.v1.WorkflowRunsRoutePayload
 */
export type WorkflowRunsRoutePayload = Message<"github.actions.v1.WorkflowRunsRoutePayload"> & {
  /**
   * @generated from field: repeated github.actions.v1.WorkflowRun workflow_runs = 1;
   */
  workflowRuns: WorkflowRun[];

  /**
   * @generated from field: string react_toggle = 2;
   */
  reactToggle: string;

  /**
   * @generated from field: string alive_channel = 3;
   */
  aliveChannel: string;

  /**
   * Deprecated: moved to WorkflowsLayoutRoutePayload. No longer populated.
   *
   * @generated from field: bool is_fork = 4 [deprecated = true];
   * @deprecated
   */
  isFork: boolean;

  /**
   * Deprecated: moved to WorkflowsLayoutRoutePayload. No longer populated.
   *
   * @generated from field: google.protobuf.StringValue workflows_path = 5 [deprecated = true];
   * @deprecated
   */
  workflowsPath?: string;

  /**
   * @generated from field: repeated int64 pinned_workflow_ids = 6;
   */
  pinnedWorkflowIds: bigint[];

  /**
   * @generated from field: bool repo_blocked = 7;
   */
  repoBlocked: boolean;

  /**
   * @generated from field: bool user_blocked = 8;
   */
  userBlocked: boolean;

  /**
   * @generated from field: bool show_only_required_workflows = 9;
   */
  showOnlyRequiredWorkflows: boolean;

  /**
   * Deprecated: moved to WorkflowsLayoutRoutePayload. No longer populated.
   *
   * @generated from field: bool show_actions_not_enabled_banner = 10 [deprecated = true];
   * @deprecated
   */
  showActionsNotEnabledBanner: boolean;

  /**
   * Deprecated: moved to WorkflowsLayoutRoutePayload. No longer populated.
   *
   * @generated from field: github.actions.v1.Banners banners = 11 [deprecated = true];
   * @deprecated
   */
  banners?: Banners;

  /**
   * @generated from field: github.actions.v1.ActionsPageHeader header = 12;
   */
  header?: ActionsPageHeader;

  /**
   * @generated from field: string title = 13;
   */
  title: string;

  /**
   * @generated from field: int32 total_pages = 14;
   */
  totalPages: number;

  /**
   * @generated from field: google.protobuf.BoolValue workflow_exists = 15;
   */
  workflowExists?: boolean;

  /**
   * @generated from field: int32 total_count = 16;
   */
  totalCount: number;

  /**
   * @generated from field: bool count_is_capped = 17;
   */
  countIsCapped: boolean;

  /**
   * @generated from field: bool page_limit_reached = 18;
   */
  pageLimitReached: boolean;

  /**
   * @generated from field: google.protobuf.StringValue recommended_date_filter = 19;
   */
  recommendedDateFilter?: string;

  /**
   * @generated from field: bool workflow_dispatch_available = 20;
   */
  workflowDispatchAvailable: boolean;

  /**
   * @generated from field: github.actions.v1.OnboardingGuidance onboarding_guidance = 21;
   */
  onboardingGuidance?: OnboardingGuidance;
};

/**
 * Describes the message github.actions.v1.WorkflowRunsRoutePayload.
 * Use `create(WorkflowRunsRoutePayloadSchema)` to create a new message.
 */
export const WorkflowRunsRoutePayloadSchema: GenMessage<WorkflowRunsRoutePayload> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 0);

/**
 * @generated from message github.actions.v1.WorkflowRun
 */
export type WorkflowRun = Message<"github.actions.v1.WorkflowRun"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int32 run_number = 2;
   */
  runNumber: number;

  /**
   * @generated from field: int64 id = 3;
   */
  id: bigint;

  /**
   * @generated from field: string workflow_file_path = 4;
   */
  workflowFilePath: string;

  /**
   * @generated from field: string run_url = 5;
   */
  runUrl: string;

  /**
   * @generated from field: string title = 6;
   */
  title: string;

  /**
   * @generated from field: string workflow_name = 7;
   */
  workflowName: string;

  /**
   * @generated from field: github.actions.v1.WorkflowRunState state = 8;
   */
  state?: WorkflowRunState;

  /**
   * @generated from field: bool is_disruptive = 9;
   */
  isDisruptive: boolean;

  /**
   * @generated from field: github.actions.v1.WorkflowRunCreatedAt created_at = 10;
   */
  createdAt?: WorkflowRunCreatedAt;

  /**
   * @generated from field: github.actions.v1.WorkflowRunBranch branch = 11;
   */
  branch?: WorkflowRunBranch;

  /**
   * @generated from field: github.actions.v1.WorkflowRunTiming timing = 12;
   */
  timing?: WorkflowRunTiming;

  /**
   * @generated from field: google.protobuf.StringValue alive_channel = 13;
   */
  aliveChannel?: string;

  /**
   * @generated from field: github.actions.v1.WorkflowRunActions actions = 14;
   */
  actions?: WorkflowRunActions;

  /**
   * @generated from field: github.common.v1.SafeHtml title_html = 15;
   */
  titleHtml?: SafeHtml;

  /**
   * @generated from field: github.actions.v1.WorkflowRunDescription description = 16;
   */
  description?: WorkflowRunDescription;
};

/**
 * Describes the message github.actions.v1.WorkflowRun.
 * Use `create(WorkflowRunSchema)` to create a new message.
 */
export const WorkflowRunSchema: GenMessage<WorkflowRun> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 1);

/**
 * @generated from message github.actions.v1.WorkflowRunState
 */
export type WorkflowRunState = Message<"github.actions.v1.WorkflowRunState"> & {
  /**
   * @generated from field: github.actions.v1.WorkflowRunStatus status = 1;
   */
  status: WorkflowRunStatus;

  /**
   * @generated from field: github.actions.v1.WorkflowRunConclusion conclusion = 2;
   */
  conclusion: WorkflowRunConclusion;
};

/**
 * Describes the message github.actions.v1.WorkflowRunState.
 * Use `create(WorkflowRunStateSchema)` to create a new message.
 */
export const WorkflowRunStateSchema: GenMessage<WorkflowRunState> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 2);

/**
 * @generated from message github.actions.v1.WorkflowRunCreatedAt
 */
export type WorkflowRunCreatedAt = Message<"github.actions.v1.WorkflowRunCreatedAt"> & {
  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: bool is_today = 2;
   */
  isToday: boolean;

  /**
   * @generated from field: bool is_current_year = 3;
   */
  isCurrentYear: boolean;
};

/**
 * Describes the message github.actions.v1.WorkflowRunCreatedAt.
 * Use `create(WorkflowRunCreatedAtSchema)` to create a new message.
 */
export const WorkflowRunCreatedAtSchema: GenMessage<WorkflowRunCreatedAt> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 3);

/**
 * @generated from message github.actions.v1.WorkflowRunBranch
 */
export type WorkflowRunBranch = Message<"github.actions.v1.WorkflowRunBranch"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;
};

/**
 * Describes the message github.actions.v1.WorkflowRunBranch.
 * Use `create(WorkflowRunBranchSchema)` to create a new message.
 */
export const WorkflowRunBranchSchema: GenMessage<WorkflowRunBranch> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 4);

/**
 * @generated from message github.actions.v1.WorkflowRunTiming
 */
export type WorkflowRunTiming = Message<"github.actions.v1.WorkflowRunTiming"> & {
  /**
   * @generated from field: github.actions.v1.WorkflowRunTimingKind kind = 1;
   */
  kind: WorkflowRunTimingKind;

  /**
   * @generated from field: string text = 2;
   */
  text: string;

  /**
   * @generated from field: google.protobuf.StringValue details_url = 3;
   */
  detailsUrl?: string;
};

/**
 * Describes the message github.actions.v1.WorkflowRunTiming.
 * Use `create(WorkflowRunTimingSchema)` to create a new message.
 */
export const WorkflowRunTimingSchema: GenMessage<WorkflowRunTiming> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 5);

/**
 * @generated from message github.actions.v1.WorkflowRunActions
 */
export type WorkflowRunActions = Message<"github.actions.v1.WorkflowRunActions"> & {
  /**
   * @generated from field: google.protobuf.StringValue cancel_url = 1;
   */
  cancelUrl?: string;

  /**
   * @generated from field: google.protobuf.StringValue workflow_file_url = 2;
   */
  workflowFileUrl?: string;

  /**
   * @generated from field: google.protobuf.StringValue delete_url = 3;
   */
  deleteUrl?: string;

  /**
   * @generated from field: google.protobuf.StringValue delete_warning_url = 4;
   */
  deleteWarningUrl?: string;

  /**
   * @generated from field: google.protobuf.StringValue stafftools_url = 5;
   */
  stafftoolsUrl?: string;

  /**
   * @generated from field: google.protobuf.StringValue stafftools_label = 6;
   */
  stafftoolsLabel?: string;

  /**
   * @generated from field: google.protobuf.StringValue pull_request_url = 7;
   */
  pullRequestUrl?: string;

  /**
   * @generated from field: google.protobuf.StringValue pull_request_label = 8;
   */
  pullRequestLabel?: string;
};

/**
 * Describes the message github.actions.v1.WorkflowRunActions.
 * Use `create(WorkflowRunActionsSchema)` to create a new message.
 */
export const WorkflowRunActionsSchema: GenMessage<WorkflowRunActions> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 6);

/**
 * @generated from message github.actions.v1.WorkflowRunDescription
 */
export type WorkflowRunDescription = Message<"github.actions.v1.WorkflowRunDescription"> & {
  /**
   * @generated from field: string primary_text = 1;
   */
  primaryText: string;

  /**
   * @generated from field: google.protobuf.StringValue link_text = 2;
   */
  linkText?: string;

  /**
   * @generated from field: google.protobuf.StringValue link_url = 3;
   */
  linkUrl?: string;

  /**
   * @generated from field: string action = 4;
   */
  action: string;

  /**
   * @generated from field: bool show_actor = 5;
   */
  showActor: boolean;

  /**
   * @generated from field: google.protobuf.StringValue actor_name = 6;
   */
  actorName?: string;

  /**
   * @generated from field: google.protobuf.StringValue actor_url = 7;
   */
  actorUrl?: string;

  /**
   * @generated from field: github.actions.v1.WorkflowRunActorType actor_type = 8;
   */
  actorType: WorkflowRunActorType;

  /**
   * @generated from field: bool show_spammy_label = 9;
   */
  showSpammyLabel: boolean;

  /**
   * @generated from field: github.actions.v1.WorkflowRunHovercard actor_hovercard = 10;
   */
  actorHovercard?: WorkflowRunHovercard;

  /**
   * @generated from field: github.actions.v1.WorkflowRunHovercard trigger_hovercard = 11;
   */
  triggerHovercard?: WorkflowRunHovercard;
};

/**
 * Describes the message github.actions.v1.WorkflowRunDescription.
 * Use `create(WorkflowRunDescriptionSchema)` to create a new message.
 */
export const WorkflowRunDescriptionSchema: GenMessage<WorkflowRunDescription> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 7);

/**
 * @generated from message github.actions.v1.WorkflowRunHovercard
 */
export type WorkflowRunHovercard = Message<"github.actions.v1.WorkflowRunHovercard"> & {
  /**
   * @generated from field: github.actions.v1.WorkflowRunHovercardType type = 1;
   */
  type: WorkflowRunHovercardType;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message github.actions.v1.WorkflowRunHovercard.
 * Use `create(WorkflowRunHovercardSchema)` to create a new message.
 */
export const WorkflowRunHovercardSchema: GenMessage<WorkflowRunHovercard> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 8);

/**
 * @generated from message github.actions.v1.Banners
 * @deprecated
 */
export type Banners = Message<"github.actions.v1.Banners"> & {
  /**
   * @generated from field: string enable_path = 1;
   */
  enablePath: string;
};

/**
 * Describes the message github.actions.v1.Banners.
 * Use `create(BannersSchema)` to create a new message.
 * @deprecated
 */
export const BannersSchema: GenMessage<Banners> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 9);

/**
 * @generated from message github.actions.v1.ActionsPageHeader
 */
export type ActionsPageHeader = Message<"github.actions.v1.ActionsPageHeader"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string description_text = 2;
   */
  descriptionText: string;

  /**
   * @generated from field: string description_link_text = 3;
   */
  descriptionLinkText: string;

  /**
   * @generated from field: string description_link_url = 4;
   */
  descriptionLinkUrl: string;

  /**
   * @generated from field: bool required_by_ruleset = 5;
   */
  requiredByRuleset: boolean;

  /**
   * @generated from field: google.protobuf.Int64Value workflow_id = 6;
   */
  workflowId?: bigint;

  /**
   * @generated from field: bool workflow_active = 7;
   */
  workflowActive: boolean;
};

/**
 * Describes the message github.actions.v1.ActionsPageHeader.
 * Use `create(ActionsPageHeaderSchema)` to create a new message.
 */
export const ActionsPageHeaderSchema: GenMessage<ActionsPageHeader> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 10);

/**
 * @generated from message github.actions.v1.OnboardingGuidance
 */
export type OnboardingGuidance = Message<"github.actions.v1.OnboardingGuidance"> & {
  /**
   * @generated from field: github.actions.v1.OnboardingGuidanceState state = 1;
   */
  state: OnboardingGuidanceState;

  /**
   * @generated from field: string tasks_path = 2;
   */
  tasksPath: string;

  /**
   * @generated from field: string continuous_integration_docs_url = 3;
   */
  continuousIntegrationDocsUrl: string;

  /**
   * @generated from field: string completed_task_title = 4;
   */
  completedTaskTitle: string;

  /**
   * @generated from field: github.actions.v1.NextOnboardingTask next_task = 5;
   */
  nextTask?: NextOnboardingTask;

  /**
   * @generated from field: string upgrade_path = 7;
   */
  upgradePath: string;

  /**
   * @generated from field: string contact_path = 8;
   */
  contactPath: string;
};

/**
 * Describes the message github.actions.v1.OnboardingGuidance.
 * Use `create(OnboardingGuidanceSchema)` to create a new message.
 */
export const OnboardingGuidanceSchema: GenMessage<OnboardingGuidance> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 11);

/**
 * @generated from message github.actions.v1.NextOnboardingTask
 */
export type NextOnboardingTask = Message<"github.actions.v1.NextOnboardingTask"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string task_path = 2;
   */
  taskPath: string;

  /**
   * @generated from field: string create_demo_repository_path = 3;
   */
  createDemoRepositoryPath: string;

  /**
   * @generated from field: string task_key = 4;
   */
  taskKey: string;
};

/**
 * Describes the message github.actions.v1.NextOnboardingTask.
 * Use `create(NextOnboardingTaskSchema)` to create a new message.
 */
export const NextOnboardingTaskSchema: GenMessage<NextOnboardingTask> = /*@__PURE__*/
  messageDesc(file_actions_v1_workflow_runs_route, 12);

/**
 * @generated from enum github.actions.v1.WorkflowRunStatus
 */
export enum WorkflowRunStatus {
  /**
   * @generated from enum value: WORKFLOW_RUN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_RUN_STATUS_REQUESTED = 1;
   */
  REQUESTED = 1,

  /**
   * @generated from enum value: WORKFLOW_RUN_STATUS_PENDING = 2;
   */
  PENDING = 2,

  /**
   * @generated from enum value: WORKFLOW_RUN_STATUS_WAITING = 3;
   */
  WAITING = 3,

  /**
   * @generated from enum value: WORKFLOW_RUN_STATUS_QUEUED = 4;
   */
  QUEUED = 4,

  /**
   * @generated from enum value: WORKFLOW_RUN_STATUS_IN_PROGRESS = 5;
   */
  IN_PROGRESS = 5,

  /**
   * @generated from enum value: WORKFLOW_RUN_STATUS_COMPLETED = 6;
   */
  COMPLETED = 6,
}

/**
 * Describes the enum github.actions.v1.WorkflowRunStatus.
 */
export const WorkflowRunStatusSchema: GenEnum<WorkflowRunStatus> = /*@__PURE__*/
  enumDesc(file_actions_v1_workflow_runs_route, 0);

/**
 * @generated from enum github.actions.v1.WorkflowRunConclusion
 */
export enum WorkflowRunConclusion {
  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_FAILURE = 2;
   */
  FAILURE = 2,

  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_NEUTRAL = 3;
   */
  NEUTRAL = 3,

  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_CANCELLED = 4;
   */
  CANCELLED = 4,

  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_ACTION_REQUIRED = 5;
   */
  ACTION_REQUIRED = 5,

  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_TIMED_OUT = 6;
   */
  TIMED_OUT = 6,

  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_SKIPPED = 7;
   */
  SKIPPED = 7,

  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_STALE = 8;
   */
  STALE = 8,

  /**
   * @generated from enum value: WORKFLOW_RUN_CONCLUSION_STARTUP_FAILURE = 9;
   */
  STARTUP_FAILURE = 9,
}

/**
 * Describes the enum github.actions.v1.WorkflowRunConclusion.
 */
export const WorkflowRunConclusionSchema: GenEnum<WorkflowRunConclusion> = /*@__PURE__*/
  enumDesc(file_actions_v1_workflow_runs_route, 1);

/**
 * @generated from enum github.actions.v1.WorkflowRunTimingKind
 */
export enum WorkflowRunTimingKind {
  /**
   * @generated from enum value: WORKFLOW_RUN_TIMING_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_RUN_TIMING_KIND_IN_PROGRESS = 1;
   */
  IN_PROGRESS = 1,

  /**
   * @generated from enum value: WORKFLOW_RUN_TIMING_KIND_DURATION = 2;
   */
  DURATION = 2,

  /**
   * @generated from enum value: WORKFLOW_RUN_TIMING_KIND_DURATION_DETAILS = 3;
   */
  DURATION_DETAILS = 3,
}

/**
 * Describes the enum github.actions.v1.WorkflowRunTimingKind.
 */
export const WorkflowRunTimingKindSchema: GenEnum<WorkflowRunTimingKind> = /*@__PURE__*/
  enumDesc(file_actions_v1_workflow_runs_route, 2);

/**
 * @generated from enum github.actions.v1.WorkflowRunActorType
 */
export enum WorkflowRunActorType {
  /**
   * @generated from enum value: WORKFLOW_RUN_ACTOR_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_RUN_ACTOR_TYPE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: WORKFLOW_RUN_ACTOR_TYPE_BOT = 2;
   */
  BOT = 2,

  /**
   * @generated from enum value: WORKFLOW_RUN_ACTOR_TYPE_AI = 3;
   */
  AI = 3,

  /**
   * @generated from enum value: WORKFLOW_RUN_ACTOR_TYPE_MANNEQUIN = 4;
   */
  MANNEQUIN = 4,
}

/**
 * Describes the enum github.actions.v1.WorkflowRunActorType.
 */
export const WorkflowRunActorTypeSchema: GenEnum<WorkflowRunActorType> = /*@__PURE__*/
  enumDesc(file_actions_v1_workflow_runs_route, 3);

/**
 * @generated from enum github.actions.v1.WorkflowRunHovercardType
 */
export enum WorkflowRunHovercardType {
  /**
   * @generated from enum value: WORKFLOW_RUN_HOVERCARD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: WORKFLOW_RUN_HOVERCARD_TYPE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: WORKFLOW_RUN_HOVERCARD_TYPE_PULL_REQUEST = 2;
   */
  PULL_REQUEST = 2,

  /**
   * @generated from enum value: WORKFLOW_RUN_HOVERCARD_TYPE_ISSUE = 3;
   */
  ISSUE = 3,

  /**
   * @generated from enum value: WORKFLOW_RUN_HOVERCARD_TYPE_COPILOT = 4;
   */
  COPILOT = 4,
}

/**
 * Describes the enum github.actions.v1.WorkflowRunHovercardType.
 */
export const WorkflowRunHovercardTypeSchema: GenEnum<WorkflowRunHovercardType> = /*@__PURE__*/
  enumDesc(file_actions_v1_workflow_runs_route, 4);

/**
 * @generated from enum github.actions.v1.OnboardingGuidanceState
 */
export enum OnboardingGuidanceState {
  /**
   * @generated from enum value: ONBOARDING_GUIDANCE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ONBOARDING_GUIDANCE_STATE_TIP = 1;
   */
  TIP = 1,

  /**
   * @generated from enum value: ONBOARDING_GUIDANCE_STATE_COMPLETED_WITH_NEXT_TASK = 2;
   */
  COMPLETED_WITH_NEXT_TASK = 2,

  /**
   * @generated from enum value: ONBOARDING_GUIDANCE_STATE_ALL_TASKS_COMPLETED = 3;
   */
  ALL_TASKS_COMPLETED = 3,
}

/**
 * Describes the enum github.actions.v1.OnboardingGuidanceState.
 */
export const OnboardingGuidanceStateSchema: GenEnum<OnboardingGuidanceState> = /*@__PURE__*/
  enumDesc(file_actions_v1_workflow_runs_route, 5);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(WorkflowRunsRoutePayloadSchema, "0afd3cf79b5e")
registerSchemaHash(WorkflowRunSchema, "2c0a29f44712")
registerSchemaHash(WorkflowRunStateSchema, "5e94c70ea912")
registerSchemaHash(WorkflowRunCreatedAtSchema, "3f3347595f51")
registerSchemaHash(WorkflowRunBranchSchema, "48f731c2dedd")
registerSchemaHash(WorkflowRunTimingSchema, "2f5ed3e66b43")
registerSchemaHash(WorkflowRunActionsSchema, "b289d552c081")
registerSchemaHash(WorkflowRunDescriptionSchema, "fae0d9e632b0")
registerSchemaHash(WorkflowRunHovercardSchema, "f6db04b9c244")
registerSchemaHash(BannersSchema, "bd2b1b790262")
registerSchemaHash(ActionsPageHeaderSchema, "9ec8e0d186e7")
registerSchemaHash(OnboardingGuidanceSchema, "d722c3e81213")
registerSchemaHash(NextOnboardingTaskSchema, "ab28d0248d26")
